<template>
</template>
<script>
  import http from "../http-common";
  import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'
export default {
	name:"Logout",
	data() {
    return {
        connected: false,
        stompvalue:''
    };
  },
	methods:{
	  ...mapActions([
       'commitsessioncheck'
      ]),
	  oauthsignout(){
	   		this.$gAuth.signOut()
			.then( () => {
			  this.logout()
			})
			.catch(error  => {
				console.log("error",error)
			})
	   },
	   logout(){
	   	   var lst=[this.$session.get("username"),this.getseen]
           http
            .post("/logout", lst)
            .then(response => {
            	this.commitsessioncheck(false)
              	this.$session.destroy();
              	this.$store.state.activetab= 1
		        this.$store.state.received_messages_store={}
		        this.$store.state.connected_store=false
		        this.$store.state.stompClient=''
		        this.$store.state.socket=''
		        this.$store.state.messagelist=[]
		        this.$store.state.newMessage=0
		        this.$store.state.seenmessage=0
		        this.$store.state.idleSecondsCounter=0
		        this.$store.state.sessioncheck=false
        		this.$router.push({ path: '/'});
            })
            .catch(e => {
              console.log(e)
            });
        }
	},
	computed: {
        ...mapGetters([
          'getseenmessage'
        ]),
        getseen: function(){
        	return this.getseenmessage
        }
      },
	created() {
	    this.oauthsignout()
  	}
      
}
</script>